import { ChangeDetectionStrategy, Component, computed, effect, input, model, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { RichTextEditorComponent } from 'shared/feature-rich-text-editor';
import { RichTextViewComponent } from 'shared/feature-rich-text-view';
import { IconDirective, MenuComponent, MenuItemDirective, MenuTriggerDirective, TooltipDirective } from 'shared/ui-common';
import { AutofocusDirective, NamePipe } from 'shared/util-common';

import { AvatarComponent } from '../../../../../../ui-common/src/lib/components/avatar/avatar.component';
import { ButtonDirective } from '../../../../../../ui-common/src/lib/components/button/button.directive';
import { InitialsPipe } from '../../../../../../util-common/src/lib/pipes/initials.pipe';
import { TimeStampUpdatedPipe } from '../../../../../../util-common/src/lib/pipes/timestamp-to-updated-at.pipe';
import { Comment } from '../../../comment.model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-comment-card-comment',
  templateUrl: './comment-card-comment.component.html',
  styleUrls: ['./comment-card-comment.component.scss'],
  imports: [
    AvatarComponent,

    IconDirective,
    MatIconModule,
    NamePipe,
    RichTextEditorComponent,
    RichTextViewComponent,
    TimeStampUpdatedPipe,
    TranslocoPipe,
    MenuComponent,
    MenuItemDirective,
    MenuTriggerDirective,
    TooltipDirective,
    InitialsPipe,
    ButtonDirective,
    AutofocusDirective,
  ],
})
export class CommentCardCommentComponent {
  public comment = input.required<Comment>();
  public path = input<string | undefined>(undefined);
  public readonly = input(false);

  public commentEdited = output<Comment>();
  public deleteComment = output<boolean>();
  public resolveComment = output<boolean>();

  public editMode = model(false);
  protected text = signal('');

  constructor() {
    effect(() => {
      this.text.set(this.comment().text ?? '');

      if (this.comment().text === '') {
        this.turnOnEditMode();
      }
    });
  }

  protected turnOnEditMode() {
    this.editMode.set(true);
  }

  protected handleEditComment() {
    this.editMode.set(false);

    this.commentEdited.emit({
      ...this.comment(),
      text: this.text(),
    });
  }

  protected handleCancelEditComment() {
    this.editMode.set(false);
    this.text.set(this.comment().text);

    if (!this.comment().createdAt) {
      this.deleteComment.emit(false);
    }
  }

  protected createdBy = computed(
    () =>
      this.comment().createdBy ?? {
        firstName: undefined,
        lastName: undefined,
      },
  );

  protected createdByInitials = computed(() => {
    const firstName = this.createdBy().firstName || '';
    const lastName = this.createdBy().lastName || '';

    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  });
}
